/* eslint-disable */

import axios from 'axios'
import EnvService from '@/services/env.service'
import qs from 'qs'
import store from '@/store'
import i18n from '@/plugins/i18n'

axios.defaults.baseURL = EnvService.apiBaseURL

axios.interceptors.request.use(function(config) {

    if (store.state.auth.accessToken) {
        config.headers['Authorization'] = `Bearer ${store.state.auth.accessToken}`;
    }

    if (config.params && config.params._auth && config.params._auth === true) {
        config._auth = true
        delete config.params._auth
    }

    config.headers['Content-Type'] = 'application/json';

    return config

}, function(error) {
    return Promise.reject(error)
})


axios.interceptors.response.use(function(response) {
    return response
}, function(error) {

    let isAuth = error.config && !!error.config._auth && error.config._auth === true

    // https://github.com/axios/axios/issues/934
    if (error.config && !isAuth && error.response && error.response.status === 401) {
        store.dispatch('auth/logout')       
        location.reload()
    }

    return Promise.reject(error)
})

function convertErrors(errors) {
    let convertedErrors = {}

    if (Array.isArray(errors)) {
        errors.forEach(function(element) {
            if (element.field && element.message) {
                if (!convertedErrors[element.field]) {
                    convertedErrors[element.field] = []
                }
                convertedErrors[element.field].push(element.message)
            }
        })
    }

    return convertedErrors
}

function mapOptions(options) {
    let convertedOptions = {
        page: options && options.page ? options.page : null,
        'per-page': options && options.itemsPerPage ? options.itemsPerPage : null,
    }

    if (options && options.sortBy[0]) {
        convertedOptions.sort = (options && options.sortDesc[0] ? '-' : '') + options.sortBy[0]
    }

    return convertedOptions
}



const ApiService = {

    login(credentials) {
        return axios.post('/users/login', credentials, {
            params: { _auth: true },
        }).then(response => {
            return Promise.resolve(response.data)
        })
    },

    logout() { //only used for logging purposes
        return axios.post('/users/logout').then(response => {
            return Promise.resolve(response.data)
        })
    },

    // defaults
    update(path, data, config = {}) {
        //config.params._lang = i18n.locale
        data._lang = i18n.locale
        return axios.put(path, data, config).then(response => {
            return Promise.resolve(response.data)
        }).catch(error => {
            return Promise.reject(convertErrors(error.response.data))
        })
    },

    create(path, data, config = {}) {
        //config.params._lang = i18n.locale
        data._lang = i18n.locale
        return axios.post(path, data, config).then(response => {
            return Promise.resolve(response.data)
        }).catch(error => {
            return Promise.reject(convertErrors(error.response.data))
        })
    },

    index(path, options = null, config = {}) {
        config.params = Object.assign({}, (config.params || {}), mapOptions(options))
        config.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'brackets' })

        config.params._lang = i18n.locale
        return axios.get(path, config).then(response => {
            if (options === null) {
                return Promise.resolve(response.data)
            }

            let total = Number(response.headers['x-pagination-total-count'] || 0)
            return Promise.resolve({ items: response.data, total })
        })
    },

    view(path, config = {}) {
        config.params = Object.assign({}, (config.params || {}))
        config.params._lang = i18n.locale
        return axios.get(path, config).then(response => {
            return Promise.resolve(response.data)
        })
    },

    delete(path, config = {}) {
        //config.params._lang = i18n.locale
        return axios.delete(path, config).then(response => {
            return Promise.resolve(response.data)
        })
    },

    dl(path, config = {}) {
        config.params = Object.assign({}, (config.params || {}))
        config.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'brackets' }) 
        config.params._lang = i18n.locale
        config.method = 'GET'
        config.responseType = 'blob'
        return axios.get(path, config).then(response => {
            return response.data
        })
    },

    // Download a file with filtering applied
    // You can send the filter data along and any errors will be preprocessed as with create() and update()
    download(path, data, config = {}) {
        config.params = Object.assign({}, (data || config.params || {}))

        config.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'brackets' }) 
        config.params._lang = i18n.locale

        config.responseType = 'blob'
        data._lang = i18n.locale
        return axios.get(path, config).then(response => {
            let filename
            try {
                filename = response.headers['content-disposition'].match('filename="(.+?)"')
                filename = filename[1]
            } catch (e) {
                filename = 'downloaded file'
            }
            response.filename = filename

            return Promise.resolve(response)
        }).catch(error => {
            return Promise.reject(convertErrors(error.response.data))
        })
    },
    
    get(path, config = {}) {
        config.params = Object.assign({}, (config.params || {}))
        return axios.get(path, config).then(response => {
            return response.data
        })
    },    
/*
    requestPasswordReset(data) {
        return axios.post('/users/request-password-reset', data, {
            params: { _auth: true },
        })
    },
*/
    resetPassword(passwordResetToken, data) {
        return axios.post(`/users/reset-password?token=${passwordResetToken}`, data).catch(error => {
            return Promise.reject(convertErrors(error.response.data))
        })
    },    

}

export default ApiService
